import {writable} from "svelte/store";

export const todoList = writable([]);